import { useEffect } from 'react';

/**
 * ConfirmDialog — custom modal to replace window.confirm()
 *
 * Props:
 *   open      : boolean
 *   title     : string (e.g. "Supprimer la catégorie")
 *   message   : string | ReactNode
 *   confirmLabel : string (default "Confirmer")
 *   cancelLabel  : string (default "Annuler")
 *   variant   : 'danger' | 'primary' (default 'danger')
 *   onConfirm : () => void
 *   onCancel  : () => void
 */
export default function ConfirmDialog({
    open, title, message,
    confirmLabel = 'Confirmer', cancelLabel = 'Annuler',
    variant = 'danger',
    onConfirm, onCancel,
}) {
    useEffect(() => {
        if (!open) return;
        const handleKey = (e) => {
            if (e.key === 'Escape') onCancel();
            if (e.key === 'Enter') onConfirm();
        };
        document.addEventListener('keydown', handleKey);
        document.body.style.overflow = 'hidden';
        return () => {
            document.removeEventListener('keydown', handleKey);
            document.body.style.overflow = '';
        };
    }, [open, onConfirm, onCancel]);

    if (!open) return null;

    return (
        <div className="confirm-overlay" onClick={onCancel}>
            <div className="confirm-dialog" onClick={(e) => e.stopPropagation()}>
                {title && <h3 className="confirm-title">{title}</h3>}
                {message && <p className="confirm-message">{message}</p>}
                <div className="confirm-actions">
                    <button className="btn btn-secondary confirm-cancel" onClick={onCancel}>
                        {cancelLabel}
                    </button>
                    <button
                        className={`btn confirm-confirm ${variant === 'danger' ? 'btn-danger' : 'btn-primary'}`}
                        onClick={onConfirm}
                        autoFocus
                    >
                        {confirmLabel}
                    </button>
                </div>
            </div>
        </div>
    );
}
